import { MenuItemProps, useTranslation } from "@mzara/component";
import { useEvaluationStateLabel } from "hooks/useEvaluationStateLabel";
import { useMemo } from "react";

export const useStateFilterMenuItems = (): MenuItemProps[] => {
    const t = useTranslation();
    const getEvaluationStateLabel = useEvaluationStateLabel();

    return useMemo(
        () => [
            { id: 0, value: undefined, label: t("std_all") },
            ...states.map((state, i) => ({
                id: i + 1,
                value: state,
                label: getEvaluationStateLabel(state),
            })),
        ],
        [states]
    );
};

const states = ["NEW", "IN_PROGRESS", "FINISHED"];
